import { DataGridPremium, GridColDef, useGridApiRef } from '@mui/x-data-grid-premium';
import { Status, useFetch } from '../../hooks/useFetch';
import {  useMemo, useState } from 'react';
import dayjs from 'dayjs'
import { ILeg } from '@aviation/cabinapp-flightservice-sdk';
import FlightDetails from './FlightDetails';

export interface IFlightListGridProps {
    dateFrom?: string;
    dateTo?: string;
}

function FlightListGrid(props : IFlightListGridProps) {
    const apiRef = useGridApiRef();
    const { status, data = [] } = useFetch<Array<any>>(`/api/flights/from/${props.dateFrom}/to/${props.dateTo}`);
    const [ showDetails, setShowDetails ] = useState<boolean>(false);
    const [ currentFlight, setCurrentFlight ] = useState<ILeg | undefined>(undefined);
    
    const rowId = (row : any) => {
        return `${row.DepDate}${row.Al}${row.No}`
    }
    const rows = useMemo(() => {
        const result = data?.map(o => { return {
            ...o,
            id: rowId(o),
            Date: dayjs(o.DepDate).format('YYYY-MM-DD'),
            Time: dayjs(o.DepDate).format('HH:mm'),
            TimeLocal: dayjs(o.DepLocalDate).format('HH:mm'),
            FlightNo: o.Al + o.No,
        }}) ?? [];
        return result.sort((a,b) => a.DepDate < b.DepDate ? -1 : 1);
    }, [data]);

    const columns: GridColDef[] = [
        { field: 'Date', headerName: 'Date', minWidth: 120 },
        { field: 'Time', headerName: 'Time UTC', minWidth: 120 },
        { field: 'TimeLocal', headerName: 'Time Local', minWidth: 120 },
        { field: 'FlightNo', headerName: 'Flight no.', minWidth: 100 },
        { field: 'Dep', headerName: 'Dep', minWidth: 80 },
        { field: 'Dest', headerName: 'Dest', minWidth: 80 },
        { field: 'AcReg', headerName: 'AC Reg.', minWidth: 80 },
        { field: 'AcType', headerName: 'AC Type', minWidth: 200 },
    ];

    return (
    <>
        <DataGridPremium
            apiRef={apiRef}
            autoHeight
            rows={rows}
            columns={columns}
            editMode='row'
            isCellEditable={(o) => false}
            rowSelection={true}
            
            // pageSize={10}
            // rowsPerPageOptions={[10]}
            getRowClassName={(params) => { return params.indexRelativeToCurrentPage % 2 === 1 ? `tui-grid-alternate-row` : ''}}
            pagination
            loading={status === Status.Fetching || status === Status.Idle}
            onRowClick={(params) => {setCurrentFlight(params.row); setShowDetails(true)}}
        />
        { currentFlight && <FlightDetails open={showDetails} flight={currentFlight} cancelAction={() => {setShowDetails(false);}} />}
    </>
        
    );
}

export default FlightListGrid;